import { ACTIVITIES, DASHBOARD, FETCH_CURRENT_USER, FETCH_USERS, LOADING } from "../Dispatchers";
import { dashboard, fetchRecentActivity, loggedInUser, user } from "../service/UserService"

export const fetchDashboardAction=()=>{
    return (dispatch)=>{
        dispatch(loaderAction(true))
        dashboard().then((response)=>{
            dispatch({type:DASHBOARD, payload:response.data})
        }).catch((error)=>{
            console.log(error)
        })
        dispatch(loaderAction(false))
    }
}
export const fetchRecentActivityAction=(page,size)=>{
    return (dispatch)=>{
        dispatch(loaderAction(true))
        return fetchRecentActivity(page,size).then((response)=>{
            dispatch({type:ACTIVITIES, payload:response.data})
            return response.data
        }).catch((error)=>{
            console.log(error)
            throw error
        }).finally(()=>{
            dispatch(loaderAction(false))
        })
    }
}
export const fetchLoggedInUser=()=>{
    return (dispatch)=>{
        loggedInUser().then((response)=>{
            dispatch({type:FETCH_CURRENT_USER, payload:response.data})
        }).catch((error)=>{
            console.log(error)
        })
    }
}
export const loaderAction=(payload)=>{
    return (dispatch)=>{
        // dispatch({type:LOADING, payload:payload})
    }
}
